export function animateReveal(element: HTMLElement): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    element.style.opacity = '1';
    return;
  }

  element.animate(
    [
      { opacity: 0, transform: 'translate3d(0,28px,0) scale(0.92) rotateX(-16deg) rotateZ(-2deg)', filter: 'brightness(1.4)' },
      { opacity: 1, transform: 'translate3d(0,-4px,0) scale(1.02) rotateX(2deg) rotateZ(1deg)', filter: 'brightness(1.12)', offset: 0.72 },
      { opacity: 1, transform: 'translate3d(0,0,0) scale(1) rotateX(0deg) rotateZ(0deg)', filter: 'brightness(1)' }
    ],
    {
      duration: 620,
      easing: 'cubic-bezier(0.18, 0.92, 0.22, 1)',
      fill: 'forwards'
    }
  );
}
